import Weather from '../components/Weather'
import { logServerSidePropsError } from '../components/utilities/log-helper.js'
import regions from '../config/regions'
import fetchQueryWrapper from '../core/fetchQueryWrapper'
import resolveImageDomain from '../data/transformers/resolveImageDomain'
import useRegion from '../hooks/useRegion'
import { RouteRedMetrics } from '../utils/metrics'
import { paramsForStoryCollection, paramsForCollection } from './category/[slug].page'

import resolveResponse from 'contentful-resolve-response'
import Head from 'next/head'

export const getWeatherStoriesCollectionByRegion = async (regionId, isPreview = false) =>
  fetchQueryWrapper(paramsForCollection('weather-stories', regionId), resolveResponse, isPreview)

export default ({ storyListByCategory, localForecastReport }) => {
  const { longName } = useRegion()

  return (
    <>
      <Head>
        <title>News 12 {longName} - Weather</title>
      </Head>
      <Weather storyListByCategory={storyListByCategory} localForecastReport={localForecastReport} />
    </>
  )
}

export async function getServerSideProps(context) {
  let redMetrics = new RouteRedMetrics({
    method: 'GET',
    route: 'weather'
  }).start()

  try {
    const regionName = context?.req?.headers?.host?.split('.')?.[0]
    const regionId = regions?.[regionName]?.contentfulId || regions.default.contentfulId
    const weatherStoriesCollection = await getWeatherStoriesCollectionByRegion(regionId)
    const categories = weatherStoriesCollection[0]?.fields?.categories

    const storyListByCategory = []
    const localForecastReport = await fetchQueryWrapper(
      {
        content_type: 'weatherConditions',
        include: 3,
        'fields.region.sys.id[in]': regionId,
        select: 'sys,fields.report'
      },
      resolveResponse
    )
    const surrogateKeyHeader = context?.res?.getHeader('Surrogate-Key')?.split(' ')

    const surrogateKeys = [
      ...surrogateKeyHeader,
      weatherStoriesCollection?.[0]?.sys?.id,
      localForecastReport?.[0]?.sys?.id,
      localForecastReport?.[0]?.fields?.report?.sys?.id
    ]

    const storyIDs = []
    let storyCategoryIDs = []
    if (categories) {
      for (let category of categories) {
        const storyCollectionParams = paramsForStoryCollection(category?.sys?.id, regionId, null, 4)
        const weatherStories = await fetchQueryWrapper(storyCollectionParams, resolveResponse)

        if (!weatherStories) {
          continue
        }

        const stories = weatherStories?.map(story => {
          storyIDs.push(story?.sys?.id)

          return {
            id: story?.sys?.id || '',
            ...story?.fields,
            thumbnail: resolveImageDomain(story?.fields?.thumbnail?.fields?.file?.url) + '?fm=webp'
          }
        })

        storyListByCategory.push({
          category: category?.fields?.name,
          stories
        })
      }

      storyCategoryIDs = categories?.map(category => category?.sys?.id)
    }

    context?.res?.setHeader(
      'Surrogate-Key',
      [...surrogateKeys, ...storyIDs, ...storyCategoryIDs]?.filter(Boolean).join(' ')
    )

    redMetrics.end({
      status: 200
    })

    context.res.chartbeatType = 'weatherConditions'

    return {
      props: {
        storyListByCategory,
        localForecastReport
      }
    }
  } catch (error) {
    logServerSidePropsError(error)

    redMetrics.end({
      status: 500,
      error: 'Failed to load page'
    })

    return { notFound: true }
  }
}
